import React from "react";
import SkipAheadButton from "./SkipAheadButton";

// skip to content doc a11y keyboard aid
const SkipMainButton: React.FC = () => {
  return (
    <SkipAheadButton
      captionId={"base.skipContent"}
      action={() =>
        document.querySelector<HTMLDivElement>("[role=main]")!.focus()
      }
    />
  );
};

export default SkipMainButton;
